import { getConterPartyName, getConterPartyLogo } from '@helpers/constants';
import { getOpportunityBySlug } from '@services/opportunities.service';
import Referral from '@components/Referral';
import NextHeadTag from '@ui/molecules/NextHeadTag';
import { HeadTagData } from '@helpers/headTagData';
import { useEffect } from 'react';
import { triggerCustomEvent } from '@helpers/miscelleanous';
import { gaEventNameEnum } from '@helpers/enums/gaEventNameEnum';
import {logEvent, moengageEventConstants} from "@services/moengage";

const SignUp = ({ opportunityDetails, isNriVisitor, isLoginMode = false }) => {
    useEffect(() => {
        triggerCustomEvent(gaEventNameEnum.VISITED_SIGNUP_PAGE);
        logEvent({eventName: moengageEventConstants.VIEWED_SIGNUP_PAGE,});
    }, []);
    return (
        <>
            <NextHeadTag {...HeadTagData?.['/signup']} />
            <div className="bg-basicWhite">
                <Referral
                    showEmail={!isLoginMode}
                    opportunityDetails={opportunityDetails}
                    isNriVisitor={isNriVisitor}
                    login={isLoginMode}
                    focusPhone={isLoginMode}
                />
            </div>
        </>
    );
};

export const getServerSideProps = async ({ req, query }) => {
    let opportunityDetails = null;

    /**
     * Commenting this code as it is not in use anymore, No need to make any changes related to this.
     */ 
    // const slug = query?.opportunity;
    // if (slug) {
    //     const response = await getOpportunityBySlug(slug);
    //     if (response.status) {
    //         const opportunity = response.entity;

    //         if (opportunity) {
    //             opportunityDetails = {
    //                 opportunityId: opportunity.id,
    //                 opportunityTitle: opportunity.title,
    //                 opportunityName: getConterPartyName(opportunity),
    //                 opportunityLogo: getConterPartyLogo(opportunity),
    //             };
    //         }
    //     }
    // }

    const isNriVisitor = query?.v2 === 'true';
    // The header's Login/Sign Up button sends ?mode=login; other links keep signup.
    const isLoginMode = query?.mode === 'login';

    return {
        props: {
            opportunityDetails,
            isNriVisitor,
            isLoginMode
        },
    };
};

export default SignUp;
